import type { AxiosResponse } from 'axios';
import type { APICommonResponse } from 'src/types/common.types';
import { MarketApiClient } from 'src/utils/client';

import type {
  MainBannerListResponse,
  MainCollectionListResponse,
  MainNewsListResponse,
  MainNoticeListResponse,
  MainPartnerListResponse,
  MainPopupListResponse,
  MainPopupNoticeListResponse,
  MainRankingListResponse,
  OriginalsListResponse,
} from '@/service/main/_legacy/_legacy.main.dto';

export const mainService = {
  getMainRolling,
  getMainVisual,
  getMainMdPick,
  getMainRanking,
  getMainCollection,
  getMainCategory,
  getMainPopup,
  getOriginalsList,

  //
  getPopupNoticeList,
  getMainNoticeList,
  getMainBannerList,
  getMainRankingList,
  getMainCollectionList,
  getMainPopupList,
  getMainNewsList,
  getMainPartnerList,
};

async function getMainRolling() {
  const res = await MarketApiClient.get('/main/banner/rolling', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainVisual() {
  const res = await MarketApiClient.get('/main/banner/visual', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainMdPick() {
  const res = await MarketApiClient.get('/main/mdPick', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainRanking() {
  const res = await MarketApiClient.get('/main/ranking', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainCollection() {
  const res = await MarketApiClient.get('/main/collection', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainCategory() {
  const res = await MarketApiClient.get('/main/category', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getMainPopup() {
  const res = await MarketApiClient.get('/main/popup', {});

  if (res.status === 200) {
    return res?.data?.data;
  } else {
    return {
      error: res.data?.message,
    };
  }
}

async function getPopupNoticeList(): Promise<APICommonResponse<MainPopupNoticeListResponse>> {
  return MarketApiClient.get('/main/popup/', {});
}

async function getMainNoticeList(): Promise<APICommonResponse<MainNoticeListResponse>> {
  return MarketApiClient.get('/main/banner/rolling');
}

async function getMainBannerList(): Promise<APICommonResponse<MainBannerListResponse>> {
  return MarketApiClient.get('/main/banner/visual');
}

async function getMainRankingList(): Promise<APICommonResponse<MainRankingListResponse>> {
  return MarketApiClient.get('/main/ranking');
}

async function getMainCollectionList(): Promise<APICommonResponse<MainCollectionListResponse>> {
  return MarketApiClient.get('/main/collection');
}

async function getMainPopupList(): Promise<APICommonResponse<MainPopupListResponse>> {
  return MarketApiClient.get('/main/popup');
}

async function getOriginalsList(): Promise<APICommonResponse<OriginalsListResponse>> {
  return MarketApiClient.get('/main/original');
}

async function getMainNewsList(): Promise<APICommonResponse<MainNewsListResponse>> {
  return MarketApiClient.get('/main/news');
}

async function getMainPartnerList(): Promise<AxiosResponse<MainPartnerListResponse>> {
  return MarketApiClient.get('https://cdn.kottonseed.io/assets/main/partners/partners.json');
}
